import * as Yup from 'yup';
import {emailSchema, phoneSchema} from '@/utils/validation';
import {IOrganizationSponsor} from '@/utils/types';
import {CATEGORY, EVENT_ID, ID} from '@/utils/constants';

export type EventSponsor = Omit<IOrganizationSponsor, typeof ID | typeof CATEGORY | typeof EVENT_ID> & {
	logo: File[];
	uniqueId: string;
};

export type OrganizationProfileValues = {
	organizationName: string;
	organizationAddress: string;
	email: string;
	taxIdNumber: string;
	phoneNumber?: string;
	city: string;
	state: string;
	zip: string;
};

export interface IOrganization {
	id: number;
	email: string;
	name: string;
	address: string;
	taxIdNumber: string;
	phoneNumber?: string;
	logo: string;
	city: string;
	state: string;
	zip: string;
}

export interface IFormProps {
	organization: IOrganization;
}

export const defaultInitialValues: OrganizationProfileValues = {
	organizationName: '',
	organizationAddress: '',
	email: '',
	taxIdNumber: '',
	phoneNumber: '',
	city: '',
	state: '',
	zip: '',
};

export const validationSchema = () => {
	return Yup.object().shape({
		organizationName: Yup.string().required('Organization name is required').trim(),
		organizationAddress: Yup.string().required('Organization address is required').trim(),
		taxIdNumber: Yup.string().trim(),
		email: emailSchema,
		phoneNumber: phoneSchema,
		city: Yup.string().required('City is required').trim(),
		state: Yup.string().required('State is required').trim(),
		zip: Yup.string().required('Zip is required').trim(),
	});
};
